





















































import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter, State} from 'vuex-class';
import {RootState, SshKey} from '@/interfaces/interfaces';
import KeyBox from '@/components/KeyBox.vue';
import KeyForm from '@/components/KeyForm.vue';
import AppLoader from '@/components/Loader.vue';
import DialogBox from '@/components/DialogBox.vue';

@Component({
  components: {DialogBox, KeyForm, KeyBox, AppLoader},
})
export default class ApiKeys extends Vue {
  @State((state: RootState) => state.isLoading) isLoading!: boolean;
  @Action fetchAvailableKeyPairs!: () => void;
  showConfirmDialog = false;
  showDialog = false;
  selectedSshKey: SshKey = {
    id: '',
    value: '',
  };

  @Getter private availableKeyPairs?: SshKey[];
  @Action private addKey!: (sshKeyValue: any) => void;
  @Action private removeKey!: (sshKey: SshKey) => void;

  openConfirmDialog(sshKey: SshKey) {
    this.selectedSshKey = sshKey;
    this.showConfirmDialog = true;
  }

  closeConfirmDialog(result: boolean) {
    this.showConfirmDialog = false;
    if (result) {
      this.removeKey(this.selectedSshKey);
    }
  }

  openDialog(sshKey: SshKey) {
    this.selectedSshKey = sshKey;
    this.showDialog = true;
  }

  closeDialog() {
    this.showDialog = false;
  }

  private async mounted() {
    await this.fetchAvailableKeyPairs();
  }

  private async saveKey(sshKeyValue: string) {
    if (sshKeyValue && sshKeyValue.length > 0) {
      this.addKey(sshKeyValue);
    }
  }

}
